<button
  class="btn btn-outline-oxxo-yellow fw-semibold rounded-5 button-size"
  (click)="handleSignUp()"
>
  Regístrate
</button>
